import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="not-found-inner">
                <figure className="not-found-image">
                  <img src="/assets/images/not-found.png" alt="Page Not Found" />
                </figure>
                <div className="text-not-found">
                  <h2>Page Not Found</h2>
                  <p>
                    We can't seem to find the page you're looking for.
                  </p>
                  <Link to="/" className="btn btn-home">
                    Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

